<template>
  <b-modal
    :visible="visible"
    @hidden="$emit('update:visible', false)"
    @shown="resetForm"
    title="Connexion"
    hide-footer
    centered
  >
    <b-form @submit.prevent="handleLogin">
      <b-form-group label="Adresse e-mail" label-for="email">
        <b-form-input
          id="email"
          type="email"
          v-model="form.email"
          required
          placeholder="ex: jean@example.com"
        />
      </b-form-group>

      <b-form-group label="Mot de passe" label-for="password">
        <b-form-input
          id="password"
          type="password"
          v-model="form.password"
          required
          placeholder="Votre mot de passe"
        />
      </b-form-group>

      <b-link href="/inscription">Pas encore de compte ?</b-link>
      <br>
      <b-link href="/auth/reset-password">Mot de passe oublie ?</b-link>
      <br><br>

      <b-button type="submit" variant="primary" block>
        Se connecter
      </b-button>

      <b-alert
        v-if="error"
        variant="danger"
        show
        class="mt-3"
      >
        {{ error }}
      </b-alert>
    </b-form>
  </b-modal>
</template>

<script>

import UserService from '@/services/user.service';

export default {
  name: "LoginModal",
  props: {
    visible: Boolean
  },
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: null
    };
  },
  methods: {
    resetForm() {
      this.form.email = "";
      this.form.password = "";
      this.error = null;
    },

    async handleLogin() {
      this.error = null;

      try {
        const res = await UserService.login(this.form.email, this.form.password);
        const data = res.data;

        // Le cookie est automatiquement stocké → pas besoin de localStorage
        this.$emit("logged-in", data.user);
        this.$emit("update:visible", false);

      } catch (err) {
        this.error = err && err.message ? err.message : "Erreur réseau.";
        console.error("Erreur login :", err);
      }
    }
  }
};
</script>
